import React, { useState } from "react";
import { useUserContext } from "../../utils/UserContext";
import { tincPermis } from "../../utils/Permisos";
import Seleccionarcategories from "./Seleccionarcategories";
import Detallscategories from "./Detallscategories";
import AjudaCataleg from "./AjudaCataleg";
import { BotoAjuda } from "./AjudaModal";
import "../dashboard_v2.css";

function Categories() {
  const [activeTab, setActiveTab] = useState("seleccionar");
  const [selectedCategoria, setSelectedCategoria] = useState(null);
  const [filterText, setFilterText] = useState("");
  const [reloadToken, setReloadToken] = useState(0);
  const [categoriesList, setCategoriesList] = useState([]);
  const [mostraAjuda, setMostraAjuda] = useState(false);

  const { rolUsuari } = useUserContext();

  const tornarLlista = (refresca = false) => {
    setActiveTab("seleccionar");
    if (refresca) setReloadToken((n) => n + 1);
  };

  const handleCategoriaSelect = (categoria) => {
    setSelectedCategoria((prev) =>
      prev && prev.idCategories === categoria.idCategories ? null : categoria
    );
  };

  const obrirFitxa = (categoria, mode) => {
    setSelectedCategoria(categoria);
    setActiveTab(mode);
  };

  const esLlista = activeTab === "seleccionar";

  return (
    <div className="dv2 dv2-page dv2-page--fill">
      {mostraAjuda && <AjudaCataleg pestanya="categories" onTancar={() => setMostraAjuda(false)} />}
      {esLlista ? (
        <>
          <div className="dv2-pageHeader">
            <div className="dv2-pageHeader-main">
              <div className="dv2-pageHeader-icon" aria-hidden="true">
                📁
              </div>
              <div>
                <h1 className="dv2-pageHeader-title">Categories</h1>
                <p className="dv2-pageHeader-subtitle">
                  Consulta i gestiona les categories de materials i productes.
                </p>
              </div>
            </div>
            <div className="dv2-pageHeader-actions">
              <BotoAjuda title="Com funcionen les Categories" onClick={() => setMostraAjuda(true)} />
              {tincPermis(rolUsuari, "CREAR") && (
                <button
                  type="button"
                  className="dv2-btn dv2-btn--primary"
                  onClick={() => {
                    setSelectedCategoria(null);
                    setActiveTab("nou");
                  }}
                >
                  Nova categoria
                </button>
              )}
            </div>
          </div>

          <Seleccionarcategories
            onCategoriaSelect={handleCategoriaSelect}
            onConsultar={(categoria) => obrirFitxa(categoria, "consultar")}
            onModificar={(categoria) => obrirFitxa(categoria, "modificar")}
            onEsborrar={(categoria) => obrirFitxa(categoria, "esborrar")}
            selectedCategoria={selectedCategoria}
            filterText={filterText}
            setFilterText={setFilterText}
            reloadToken={reloadToken}
            setCategoriesList={setCategoriesList}
          />
        </>
      ) : (
        <Detallscategories
          mode={activeTab}
          categoria={activeTab === "nou" ? null : selectedCategoria}
          categories={categoriesList}
          onNavigate={setSelectedCategoria}
          onCancel={() => tornarLlista(false)}
          onDeleted={() => tornarLlista(true)}
          onCanviarMode={(modeNou) => setActiveTab(modeNou)}
          onSave={(updated) => {
            if (activeTab === "nou") {
              tornarLlista(true);
              return;
            }
            setSelectedCategoria(updated);
            setCategoriesList((prev) =>
              (prev || []).map((c) =>
                Number(c.idCategories) === Number(updated.idCategories) ? { ...c, ...updated } : c
              )
            );
            setActiveTab("consultar");
          }}
        />
      )}
    </div>
  );
}

export default Categories;
